export default defineNuxtPlugin({
    name: 'cromi-resource-recovery',
    enforce: 'pre',
    setup(nuxtApp) {
        nuxtApp.hook('app:mounted', () => window.__cromiRecovery?.ready())
        nuxtApp.hook('page:finish', async () => {
            await nextTick()
            window.__cromiRecovery?.capture()
        })
        nuxtApp.hook('app:chunkError', () => window.__cromiRecovery?.fail())
        nuxtApp.hook('app:error', (error) =>
            window.__cromiRecovery?.resourceError(error)
        )
    },
})
